export function isDevOrLocalOrTest(env: string) {
  return ['development', 'local', 'test'].includes(env)
}

export function isDevOrLocal(env: string) {
  return ['development', 'local'].includes(env)
}
